
import axios from 'axios';
import Store from "../store/store";

const requestUser = Store.dispatch("getAuthUser");
const requestCycles = Store.dispatch("getCycles");
const requestWarnings = Store.dispatch("getWarnings");

export default function () {
    return axios.all([requestUser, requestWarnings, requestCycles,])

}
